import AcadimecRecord from '@/router/modules/AcadimecRecord/AcadimecRecord';
import CertificateTemplates from '@/router/modules/CertificateTemplates/CertificateTemplates';
import  Certificates from '@/router/modules/Certificates/Certificates';
import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import Course from '@/router/modules/Course/Course';
import Exam from '@/router/modules/Exam/Exam';
import Period from '@/router/modules/Period/Period';
import SystemConfigure from "@/router/modules/SystemConfigure/SystemConfigure";
import MajorSeason from "@/router/modules/MajorSeason/MajorSeason";
import Major from "@/router/modules/Major/Major";
import BodyView from "@/layout/bodyView.vue";
// User & Auth Routes
import User from "@/router/modules/User/User";
import Dashboard from "@/router/modules/Dashboard/Dashboard";
import UserReport from "@/router/modules/UserReport/UserReport";
import AuthRoute from "@/router/modules/Auth/Auth";
import Permission from "@/router/modules/Permission/Permission";
import Auth from "@/API/Auth";
import { generatePermissionHash } from "@/utils/hash"; // Import your hash function
import { hasPermission, resolveFirstPermittedPath } from "@/utils/helpers";
import {
  isStudentUser,
  isStaffUser,
  isStudentSelfServicePath,
  isStaffSelfServicePath,
} from "@/utils/portalAccess";

// Job & Department
import Job from "@/router/modules/Job/Job";
import Department from "@/router/modules/Department/Department";
import Role from "@/router/modules/Role/Role";
import Position from "@/router/modules/Position/Position";
import Team from "@/router/modules/Team/Team";
import Color from "@/router/modules/Color/Color";

import EmailConfig from "@/router/modules/EmailConfig/EmailConfig";
import Log from "@/router/modules/Log/Log";
import LogSetting from "@/router/modules/LogSetting/LogSetting";
import NotificationSetting from "@/router/modules/NotificationSetting/NotificationSetting";
import Notification from "@/router/modules/notification/notification";
import AllNotification from "./modules/AllNotification/AllNotification";
import Cookies from "js-cookie";
import Errors from "./modules/Errors/Errors";
import Language from "@/router/modules/Language/Language";
import Translate from "@/router/modules/Translate/Translate";
import Room from "./modules/Room/Room";
import Campus from "@/router/modules/Campus/Campus";
import Grade from "@/router/modules/Grade/Grade";
import Degree from "@/router/modules/Degree/Degree";
import Plan from '@/router/modules/Plan/Plan';
import Section from '@/router/modules/Section/Section';
import SectionGroup from '@/router/modules/SectionGroup/SectionGroup';
import schedule from '@/router/modules/schedule/schedule';
import Lectures from '@/router/modules/Lectures/Lectures';
import Marks from '@/router/modules/marks/marks';
import Student from '@/router/modules/Student/Student';
import StudentDashboard from '@/router/modules/Student/StudentDashboard';
import StudentSchedule from '@/router/modules/Student/StudentSchedule';
import StudentEnrollment from '@/router/modules/Enrollment/StudentEnrollment';
import Teacher from '@/router/modules/Teacher/Teacher';
import Staff from '@/router/modules/Staff/Staff';
import StaffDashboard from '@/router/modules/Staff/StaffDashboard';
import ElectronicAdmissionSetting from '@/router/modules/ElectronicAdmissionSetting/ElectronicAdmissionSetting';
import ConfigrationGrade from '@/router/modules/ConfigrationGrade/ConfigrationGrade';
import Nationality from '@/router/modules/Nationality/Nationality';
import Service from '@/router/modules/Service/Service';
import Qualification from '@/router/modules/Qualification/Qualification';
import AptitudeGrade from '@/router/modules/AptitudeGrade/AptitudeGrade';
import AcceptanceRequirement from '@/router/modules/AcceptanceRequirement/AcceptanceRequirement';
import OnlineAdmission from '@/router/modules/OnlineAdmission/OnlineAdmission';
import Workflow from '@/router/modules/Workflow/Workflow';
import WorkflowCategory from '@/router/modules/WorkflowCategory/WorkflowCategory';
import Reports from '@/router/modules/Reports/Reports';

declare global {
  interface Window {
    routerData?: string;
  }
}

const routes: Array<RouteRecordRaw> = [
  ...AuthRoute,
  // Public (no-auth) pages
  {
    path: '/public/online-admission',
    alias: '/application',
    name: 'PublicOnlineAdmission',
    component: () => import('@/views/Public/OnlineAdmissionPublic.vue'),
    meta: { requiresAuth: false, title: 'Online Registeration' },

    beforeEnter: () => {
      localStorage.removeItem('selectedLanguageCode');
      localStorage.setItem('selectedLanguageCode', 'ar');
    },
  },
  {
    path: '/public/print-online-admission',
    name: 'PublicPrintOnlineAdmission',
    component: () => import('@/views/Public/PrintOnlineAdmissionPublic.vue'),
    meta: { requiresAuth: false, title: 'Print Online Registeration' },

    beforeEnter: () => {
      localStorage.removeItem('selectedLanguageCode');
      localStorage.setItem('selectedLanguageCode', 'ar');
    },
  },
  {
    path: '/print/online-admission/:id/specific-action',
    name: 'OnlineAdmissionSpecificActionPrint',
    component: () => import('@/views/Page/OnlineAdmission/OnlineAdmissionSpecificActionPrint.vue'),
    meta: { requiresAuth: false, title: 'Print Specific Action' },
  },
  {
    path: '/print/online-admission/:id',
    name: 'OnlineAdmissionFormPrint',
    component: () => import('@/views/Public/PrintOnlineAdmissionPublic.vue'),
    meta: { requiresAuth: false, title: 'Print Online Admission Form' },
    beforeEnter: () => {
      localStorage.removeItem('selectedLanguageCode');
      localStorage.setItem('selectedLanguageCode', 'ar');
    },
  },
  {
    path: "/",
    name: "home",
    component: BodyView,
    meta: {
      title: "Default |  ",
    },
    children: [
      ...CertificateTemplates,
      ...Certificates,
      ...Permission,
      ...User,
      ...Dashboard,
      ...UserReport,
      ...Job,
      ...Department,
      ...Role,
      ...Team,
      ...Position,
      ...Color,
      ...NotificationSetting,
      ...Notification,
      ...AllNotification,
      ...LogSetting,
      ...Log,
      ...EmailConfig,

      // modules
      ...AcadimecRecord,
      ...Campus,
      ...Room,
      ...Degree,
      ...Grade,
      ...Major,
      ...MajorSeason,
      ...SystemConfigure,
      ...Period,
      ...Exam,
      ...Course,
      ...Plan,
      ...Section,
      ...SectionGroup,
      ...schedule,
      ...Lectures,
      ...Marks,
      ...Student,
      ...StudentDashboard,
      ...StudentSchedule,
      ...StudentEnrollment,
      ...Teacher,
      ...Staff,
      ...StaffDashboard,
      ...ElectronicAdmissionSetting,
      ...Qualification,
      ...Service,
      ...Nationality,
      ...ConfigrationGrade,
      ...AptitudeGrade,
      ...AcceptanceRequirement,
      ...OnlineAdmission,
      ...Workflow,
      ...WorkflowCategory,
      ...Reports,

      // KIOSK SERVICE
      ...Language,
      ...Translate,
    ],
  },
  ...Errors,
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

// Utility functions
function getCookie(name: string): string | null {
  const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
  return match ? decodeURIComponent(match[2]) : null;
}

function base64UrlDecode(base64Url: string): string {
  let base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  const padding = base64.length % 4;
  if (padding) {
    base64 += "=".repeat(4 - padding);
  }
  return atob(base64);
}

function decodeJWT(token: string) {
  const parts = token.split(".");
  if (parts.length !== 3) {
    throw new Error("Invalid JWT format");
  }
  const header = JSON.parse(base64UrlDecode(parts[0]));
  const payload = JSON.parse(base64UrlDecode(parts[1]));
  return { header, payload };
}

// Function to get JWT token from cookies
function getTokenFromCookies(): string {
  let token = "";
  let i = 0;
  while (Cookies.get(`api_token_part${i + 1}`)) {
    token += Cookies.get(`api_token_part${i + 1}`);
    i++;
  }
  return token;
}

/** Default landing route after login or when visiting `/` while authenticated */
function resolveDefaultHomeRoute(user: Record<string, any> | null | undefined) {
  if (user && isStudentUser(user)) {
    return { name: "StudentDashboard" };
  }
  if (user && isStaffUser(user)) {
    return { name: "StaffDashboard" };
  }
  if (Auth.isSuperAdmin() || hasPermission("Dashboard", "show")) {
    return { name: "Dashboard" };
  }
  const firstPermitted = resolveFirstPermittedPath();
  if (firstPermitted) {
    return { path: firstPermitted };
  }
  return { name: "NotAuthorized" };
}

function redirectToPermittedHome(toPath?: string) {
  const home = resolveDefaultHomeRoute(Auth.USER);
  const homePath =
    "path" in home && home.path
      ? home.path
      : home.name === "Dashboard"
        ? "/dashboard"
        : home.name === "StudentDashboard"
          ? "/student-dashboard"
          : home.name === "StaffDashboard"
            ? "/staff-dashboard"
            : null;
  if (homePath && homePath !== toPath) {
    return home;
  }
  return { name: "NotAuthorized" };
}

function isRootAppRoute(to: { path: string; name?: string | symbol | null }) {
  return to.path === "/" || to.name === "home";
}

// Main authentication guard
router.beforeEach(async (to, from, next) => {
  try {
    const isAuthenticated = await Auth.loggedIn();

    if (
      isAuthenticated &&
      (to.name === "Login" || to.name === "ForgotPassword")
    ) {
      const redirectPath =
        (to.query?.redirect as string) ||
        resolveDefaultHomeRoute(Auth.USER);
      return next(redirectPath);
    }

    if (
      to.matched.some(
        (record) => record.meta && record.meta.requiresAuth === false,
      )
    ) {
      return next();
    }

    if (isRootAppRoute(to)) {
      if (!isAuthenticated) {
        return next({ name: "Login" });
      }
      return next(resolveDefaultHomeRoute(Auth.USER));
    }

    if (!isAuthenticated) {
      return next({ name: "Login", query: { redirect: to.fullPath } });
    }

    // Build controller path from route
    if (to.matched && to.matched.length > 1) {
      const component = to.matched[1];
      if (component && component.name && typeof component.name === "string") {
        const convertedPath = component.name
          .replace("/", "")
          .split("/")
          .map((part: string) => part.charAt(0).toUpperCase() + part.slice(1))
          .join("\\")
          .split("\\:id")
          .join("");

        // Extract the base module name from the route path for permission checking.
        // Detail/child routes like /risk/:id (name: "RiskView") should check the
        // base module "Risk", not "RiskView". We use the first path segment after "/".
        // Kebab-case paths (e.g. "third-party-profile") are converted to PascalCase ("ThirdPartyProfile").
        const pathSegments = (component.path || "")
          .replace(/^\//, "")
          .split("/")
          .filter(Boolean);
        const baseModule =
          pathSegments.length > 0
            ? pathSegments[0]
              .split("-")
              .map(
                (seg: string) => seg.charAt(0).toUpperCase() + seg.slice(1),
              )
              .join("")
            : convertedPath;

        // Always set routerData to the base module controller for permission checks
        window.routerData = baseModule + "\\" + baseModule + "Controller\\";

        // Super admin has access to all routes
        if (Auth.isSuperAdmin()) {
          return next();
        }

        const portalUser = Auth.USER;
        if (
          portalUser &&
          isStudentUser(portalUser) &&
          isStudentSelfServicePath(to.path)
        ) {
          return next();
        }
        if (
          portalUser &&
          isStaffUser(portalUser) &&
          isStaffSelfServicePath(to.path)
        ) {
          return next();
        }

        // Regular user - check permissions using role-based approach
        // 1) Check meta.permission if defined (supports "Model.action" format)
        const metaPerm = to.meta?.permission as string | undefined;
        if (metaPerm) {
          if (metaPerm.includes('.')) {
            const [model, action] = metaPerm.split('.');
            if (hasPermission(model, action || 'show')) {
              return next();
            }
          } else if (hasPermission(metaPerm, 'show')) {
            return next();
          }
          return next(redirectToPermittedHome(to.path));
        }

        // 2) Try the base module first (e.g. "Risk" for /risk/:id),
        // then fall back to the full convertedPath (e.g. "RiskView")
        if (
          hasPermission(baseModule, "show") ||
          hasPermission(convertedPath, "show")
        ) {
          return next();
        } else {
          console.log("User does not have required permissions");
          return next(redirectToPermittedHome(to.path));
        }
      } else {
        return next({ name: "NotFound" });
      }
    } else {
      return next({ name: "NotFound" });
    }
  } catch (error) {
    console.error("Router guard error:", error);
    return next({ name: "Login" });
  }
});

// Update document title based on route meta
router.beforeEach((to) => {
  if (typeof to.meta?.title === "string") {
    document.title = to.meta.title;
  }
});

export default router;

